import { combineReducers } from 'redux';

import locale from './data/locale';
import messages from './data/messages';

export default combineReducers({
  data: combineReducers({
    locale,
    messages,
  }),
});
